import { NgModule } from '@angular/core';

import { provideConfig } from '@spartacus/core';

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        successPointsContainerFeature: {
          cmsComponents: ['SuccessPointsContainerComponent'],
          module: () => import('./success-points-container').then((m) => m.DpSuccessPointsContainerModule),
        },
        circularContentContainerFeature: {
          cmsComponents: ['CircularContentContainerComponent'],
          module: () => import('./circular-content-container').then((m) => m.DpCircularContentContainerModule),
        },
        timelineFeature: {
          cmsComponents: ['TimelineComponent'],
          module: () => import('./timeline').then((m) => m.DpTimelineModule),
        },
      },
    }),
  ],
})
export class DpAboutUsFeatureModule {}
